// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"styles_PageHeader__G_IkM"};